module.exports = __webpack_public_path__ + "static/media/logo__Store.566df4ce.svg";